import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const rocksdbRWRaftSchema: Schema = {
  title: 'Raft',
  level: 3,
  columns: commonColumns
}
